import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircleIcon } from '@heroicons/react/24/solid';

const SubscriptionCancelled: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-grey flex items-center justify-center">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <XCircleIcon className="w-24 h-24 text-red mx-auto" />
        </div>

        <h1 className="text-4xl font-bold text-white mb-4">
          Subscription Cancelled
        </h1>

        <p className="text-xl text-white text-opacity-80 mb-8">
          Your subscription process was cancelled. <br /> No charges were made.
        </p>

        <p className="text-white text-opacity-60 mb-8">
          You can always come back and subscribe when you're ready to unlock the
          full power of Superpower Social.
        </p>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-violet hover:bg-violet hover:brightness-110 text-white font-medium py-3 px-6 rounded-full transition-all duration-200"
          >
            Return to App
          </button>

          {/* <button
            onClick={() => window.open('https://www.superpower.social/pricing', '_blank')}
            className="w-full bg-white bg-opacity-10 hover:bg-opacity-20 text-white font-medium py-3 px-6 rounded-full transition-all duration-200"
          >
            View Pricing Plans
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancelled;
